import { useTranslation } from 'react-i18next';
import {
  StyledDistroDark,
  StyledDistroLight,
  StyledPlusTextLight,
  StyledPlusSign,
  StyledPlusSignLight,
  StyledPlusText,
  StyledStack,
} from './styled';

type PropsType = {
  isLightBackground?: boolean;
};

const DistroPlus = ({ isLightBackground }: PropsType) => {
  const { t } = useTranslation();

  if (isLightBackground) {
    return (
      <StyledStack>
        <StyledDistroDark>
          {t('distribution:upsellModal:labels:distro')}
        </StyledDistroDark>
        <StyledPlusText>
          {t('distribution:upsellModal:labels:plus')}
        </StyledPlusText>
        <StyledPlusSign>+</StyledPlusSign>
      </StyledStack>
    );
  }

  return (
    <StyledStack>
      <StyledDistroLight>
        {t('distribution:upsellModal:labels:distro')}
      </StyledDistroLight>
      <StyledPlusTextLight>
        {t('distribution:upsellModal:labels:plus')}
      </StyledPlusTextLight>
      <StyledPlusSignLight>+</StyledPlusSignLight>
    </StyledStack>
  );
};

export default DistroPlus;
